import fetch from 'isomorphic-unfetch';

export async function fetchData(
    url: string,
    options: object = { method: 'get' },
): Promise<any> {
    const response = await fetch(url, {
        ...options,
    });

    if (!response.ok) {
        throw new Error(
            `Unable to make request - got ${response.status} with body: ${response.body}`,
        );
    }
    try {
        return await response.json();
    } catch (e) {
        throw new Error(`Unable to parse JSON from ${response.body}`);
    }
}

export function isEmpty(obj?: object) {
    if (obj && typeof obj === 'object') {
        return Object.keys(obj).length === 0;
    }
    return true;
}

export function isValidUrl(url: string) {
    const hostRegex = new RegExp(/^finn$/);
    const tldRegex = new RegExp(/no(:+\d+)?/);
    try {
        const host = new URL(url).host;
        const values = host.split('.').slice(-2);
        return hostRegex.test(values[0]) && tldRegex.test(values[1]);
    } catch (e) {
        return false;
    }
}
